var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"toggleable":"lg"}},[_c('b-collapse',{attrs:{"id":"navbar-toggle-collapse","is-nav":""}},[_c('ul',{staticClass:"menu-items"},[_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":"/","active-class":"active"}},[_vm._v(" NLC Vesting ")])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }